









































































































import { Component, Mixins } from "vue-property-decorator";
import ModalComponent from "./modal-component.vue";
import { appUpdatesApiProvider } from "@/providers/app-updates-api-provider";
import moment from "moment";
import store from "@/stores/store";
import { UserRole } from "@/interfaces/user";
import DatePickerFormComponent from "@/components/_shared/forms/date-picker-form-component.vue";
import { MessageType } from "@/components/_shared/template/app-snackbar.vue";
import { i18n } from "@/main";

@Component({ name: "updates-modal", components: { DatePickerFormComponent, ModalComponent } })
export default class UpdatesModal extends Mixins(ModalComponent) {
  superAdmin = store.getters["user/getUser"].role == UserRole.superadmin;
  update = { date: null, title: null, description: null };
  updates = [];
  editMode = false;

  async onOpening() {
    await this.getAll();
    this.toggleModal(true);
  }

  async getAll() {
    const response = await appUpdatesApiProvider.getAll([]);
    if (response) {
      this.updates = response;
    }
  }

  mounted() {
    this.$eventHub.$on("open-updates-modal", this.onOpening);
  }

  beforeDestroy() {
    this.$eventHub.$off("open-updates-modal");
  }

  parseDate(date) {
    return moment(date).format("L");
  }

  async saveUpdate() {
    if (!this.update.title || !this.update.date || !this.update.description) {
      this.$eventHub.$emit("show-snackbar", {
        type: MessageType.warning,
        mainText: i18n.t("updates.form_empty"),
        timeout: 5000,
      });

      return;
    }

    await appUpdatesApiProvider.create(this.update);
    this.editMode = false;

    await this.getAll();
  }

  async deleteUpdate(update: any) {
    await appUpdatesApiProvider.remove(update);
    this.$eventHub.$emit("show-snackbar", {
      type: MessageType.success,
      mainText: i18n.t("message.updates_delete_successfully"),
      timeout: 5000,
    });

    await this.getAll();
  }
}
